export default "<app-faq-list>Loading ...</app-faq-list>\n"